import AdminDocuments from './admin';
import ClientDocuments from './client';
import ContractorDocuments from './contractor';

const tenants = {
    admin: AdminDocuments,
    client: ClientDocuments,
    contractor: ContractorDocuments
};

export default tenants;



// WEBPACK FOOTER //
// ./src/pages/documents/tenants/index.jsx